import { SectionDetails } from "@components/Modules/HeaderNew/headerMenuConstants";
import {
  ENABLE_NEW_HEADER_FOOTER,
  MYSPH_NOT_AVAILABLE,
  QUICKNEWS_FLAG,
} from "@helper/getEnvVariables";
import { List, ListItem } from "@sphtech/sph-web-ui/elements/List";
import cx from "classnames";
import { Link, useLocation } from "react-router";

import { HeaderMenuType } from "./headerMenuTypes";

type HeaderMenuListProps = {
  testId: string;
  items: SectionDetails[];
  type: HeaderMenuType;
  addActiveColor?: boolean;
};

export function HeaderMenuList({
  testId,
  items,
  type,
  addActiveColor = false,
}: HeaderMenuListProps) {
  const { pathname } = useLocation();

  const isActive = (location: string): boolean => {
    const pathnameOnly = location.split("?")[0];
    const sectionName = pathname.split("/")[1];
    if (sectionName === "podcasts" || sectionName === "videos") {
      return pathnameOnly === "/podcasts";
    }
    return pathname === pathnameOnly || `/${sectionName}` === pathnameOnly;
  };

  const newMasthead = ENABLE_NEW_HEADER_FOOTER;

  const topicsTypeContainerClass = newMasthead
    ? "lg:gap-0 lg:justify-between lg:flex-grow-no-shrink"
    : "lg:gap-xs xl:gap-sm";
  const topicsTypeWrapperClass = newMasthead
    ? "lg:text-sm"
    : "lg:text-xs lg:w-[71px] xl:w-[78px]";
  const topicsTypeItemClass = newMasthead
    ? "lg:text-brand-primary"
    : "lg:text-text-inverse";

  const secTopicsTypeItemClass = newMasthead
    ? "lg:text-brand-primary"
    : "text-text-inverse";

  const menuLinkClass = newMasthead ? "font-regular" : "font-semimedium";
  const menuLinkActiveClass = newMasthead ? "font-medium" : "font-semibold";

  const miscTypeItemClass = newMasthead
    ? "text-xs"
    : "text-xxs text-neutral-700";

  return (
    <List
      testId={`${testId}-${type}-menuList`}
      key={`${testId}-${type}-menu`}
      className={cx(
        type === "topics" &&
          `flex items-center justify-center gap-md ${topicsTypeContainerClass}`,
        type === "secTopics" &&
          "flex items-center justify-center lg:gap-sm xl:gap-md",
        type === "misc" && "flex items-center justify-center",
      )}
    >
      {items.map((item: SectionDetails, index: number) => {
        if (item.title === "Sekilas Berita" && QUICKNEWS_FLAG !== "1") {
          return <></>;
        }
        const showSeparator =
          item.title === "ePaper" && parseInt(MYSPH_NOT_AVAILABLE) === 1
            ? false
            : true;
        return (
          <ListItem
            key={`${testId}-item-${index}`}
            testId={`${testId}-item-${index}`}
            className={cx(
              "cursor-pointer",
              type === "topics" &&
                `flex items-center justify-center text-sm ${topicsTypeWrapperClass} lg:font-regular lg:leading-[35px] whitespace-nowrap`,
              (type === "topics" || type === "secTopics") &&
                item.title === "Bahasa & Budaya" &&
                "lg:!w-[105px] xl:!w-[115px]",
              (type === "topics" || type === "secTopics") &&
                (item.title === "Videos" ||
                  item.title === "Gen G" ||
                  item.title === "Sukan" ||
                  item.title === "Wacana" ||
                  item.title === "Ekonomi" ||
                  item.title === "Kuiz BH" ||
                  item.title === "Podcast" ||
                  item.title === "Dunia") &&
                "lg:!w-[53px] xl:!w-[64px]",
              type === "secTopics" &&
                "flex items-center justify-center text-xs font-regular leading-[35px] lg:w-[70px]",
              type === "secTopics" &&
                item.title == "Akses Percuma" &&
                "lg:!w-[100px]",
              type === "topics" && item.title == "Multimedia" && "lg:!w-[90px]",
              (type === "topics" || type === "secTopics") &&
                item.title == "Pengguna Berdaftar" &&
                "lg:!w-[130px]",
              type === "misc" && miscTypeItemClass,
              type === "mobileMain" &&
                "flex h-[54px] items-center [&_a]:text-text-inverse [&_a]:text-sm [&_a]:font-semimedium [&_a]:w-full",
              type === "mobileSection" &&
                "flex h-[54px] items-center [&_a]:w-full [&_a]:text-sm [&_a]:font-semimedium",
              type === "mobileMisc" &&
                "flex h-[54px] [&_a]:text-text-inverse [&_a]:text-sm [&_a]:font-semimedium [&_a]:w-full",
              type === "mobileSecondary" &&
                "flex h-[54px] [&_a]:text-gold-200 [&_a]:text-sm [&_a]:font-semimedium [&_a]:w-full",
            )}
          >
            <div
              className={`flex items-center gap-xxs min-w-max ${
                addActiveColor &&
                isActive(item.url) &&
                type === "secTopics" &&
                `border-b-[3px] border-${item.selectedColor}`
              } ${type === "misc" && "gap-0"}`}
            >
              <Link
                reloadDocument
                key={index}
                to={item.url}
                className={cx(
                  type === "misc" && "font-regular text-brand-primary",
                  type === "topics" &&
                    `text-text-muted ${topicsTypeItemClass} transition-transform duration-300 ease-out hover:opacity-100 hover:font-semibold`,
                  type === "secTopics" &&
                    `${secTopicsTypeItemClass} transition-transform duration-300 ease-out hover:opacity-100 hover:font-semibold`,
                  type === "topics" || type === "secTopics"
                    ? isActive(item.url)
                      ? `${menuLinkActiveClass} opacity-100`
                      : `${menuLinkClass} opacity-90`
                    : "",
                  type === "mobileSection" ? "text-text-inverse" : "",
                )}
                {...(item.newTab && {
                  target: "_blank",
                  rel: "noopener noreferrer",
                })}
              >
                {/* Check if it is BHku and has an image; if so, show the image, else show title */}
                {item.title === "BHku" && item.images ? (
                  <img
                    src={item.images}
                    alt={item.title}
                    className="h-[13px] w-auto object-contain"
                  />
                ) : newMasthead &&
                  item.title === "Sekilas Berita" &&
                  type === "misc" ? (
                  <div className="flex items-center gap-1">
                    <img
                      src={item.images}
                      alt={item.title}
                      className="h-[13px] w-auto object-contain"
                    />
                    <span>{item.title}</span>
                  </div>
                ) : (
                  item.title
                )}
              </Link>
              {type === "misc" && showSeparator && (
                <span className="px-xxs text-neutral-300 text-sm font-regular">
                  |
                </span>
              )}
            </div>
          </ListItem>
        );
      })}
    </List>
  );
}
